module.exports = {

  billingData: "Billing information",
  productData: "Product",
  back: "Back to offer",
  next: "Proceed to payment"

}


// WEBPACK FOOTER //
// ../i18n/en/order.js